import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StatusBadgeComponent } from '../../../../../components/common/status-badge/status-badge.component';

export interface RepresentationEntry {
  date: string;
  status: string;
}

@Component({
  selector: 'app-representation-modal',
  standalone: true,
  imports: [CommonModule, StatusBadgeComponent],
  templateUrl: './representation-modal.component.html',
  styleUrl: './representation-modal.component.scss',
})
export class RepresentationModalComponent {
  @Input() representationData: RepresentationEntry[] = [];

  activeModal = inject(NgbActiveModal);
  isActive: boolean = false;

  readonly pageSize = 8;
  currentPage = 1;

  get totalPages(): number {
    return Math.ceil(this.representationData.length / this.pageSize) || 1;
  }

  get currentPageData(): RepresentationEntry[] {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.representationData.slice(start, start + this.pageSize);
  }

  prevPage(): void {
    if (this.currentPage > 1) this.currentPage--;
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) this.currentPage++;
  }

  formatDate(dateStr: string): string {
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return dateStr;
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const hh = String(d.getHours()).padStart(2, '0');
    const min = String(d.getMinutes()).padStart(2, '0');
    const ss = String(d.getSeconds()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}\n${hh}:${min}:${ss}`;
  }
}
